import React from 'react';
import { useOutletContext } from 'react-router-dom';

export type MarketPlaceOutletCtx = {
  setDataLoading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const useMarketPlaceLayoutCtx = () => useOutletContext<MarketPlaceOutletCtx>();
